<mat-accordion>
  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="col-md-6"><h6>Data Acquisition Layout</h6></div>
        <div class="col-md-6" *ngIf="siteId !== '' && siteId !== 'default'">
          <h6>Site Id: {{ siteId }}</h6>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-expansion-panel
      *ngFor="let process of processes"
      class="my-expansion"
      id="{{ process.name }}"
      expanded="false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title
          ><h6>{{ process.name }}</h6></mat-panel-title
        >
      </mat-expansion-panel-header>
      <mat-table #tableM [dataSource]="process.loads" matSort>
        <ng-container matColumnDef="loadName">
          <mat-header-cell *matHeaderCellDef>Load Name</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.name }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="loadId">
          <mat-header-cell *matHeaderCellDef>Machine ID</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.loadId }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Location">
          <mat-header-cell *matHeaderCellDef>Meter Location</mat-header-cell>
          <mat-cell *matCellDef="let item"></mat-cell>
        </ng-container>

        <ng-container matColumnDef="meterId">
          <mat-header-cell *matHeaderCellDef>Logical MeterID</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <button
              (click)="openAssignMeterModal(item)"
              id="meterIdButton"
              class="btn RoundedBtn mat-raised-button"
            >
              {{ item.meter ? item.meter.meterId : '' }}
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="insiteMeterID">
          <mat-header-cell *matHeaderCellDef>Physical MeterID</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            item.meter ? item.meter.insiteMeterID : ''
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="dcuID">
          <mat-header-cell *matHeaderCellDef>DCU ID</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            item.meter ? item.meter.dcuID : ''
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ctMake">
          <mat-header-cell *matHeaderCellDef>CT Type</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            item.meter ? item.meter.ctMake : ''
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ctRatingPrimary">
          <mat-header-cell *matHeaderCellDef>CT Rating</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            item.meter ? item.meter.ctRatingPrimary : ''
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ctAccuracy">
          <mat-header-cell *matHeaderCellDef>CT Accuracy</mat-header-cell>
          <mat-cell *matCellDef="let item">{{
            item.meter ? item.meter.ctAccuracy : ''
          }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let item; columns: displayedColumns"></mat-row>
      </mat-table>
    </mat-expansion-panel>
    <mat-action-row>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
        <button
          (click)="previousStep($event)"
          id="previousbtn"
          bciprimarybutton
          class="button-primary"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-left-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Previous
        </button>
        <button
          type="submit"
          bciprimarybutton
          class="button-primary"
          id="submitbtn"
          style="margin-left: 3px"
          (click)="submitDACFrom()"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon> </span
          >Submit
        </button>

        <button
          (click)="nextStep($event)"
          bciprimarybutton
          class="button-primary"
          id="nextbtn"
          style="margin-left: 3px"
        >
          Next
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-arrow-right-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
        </button>
      </div>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
